module.exports = __webpack_public_path__ + "media/images/flags/4x3/srb-53126246f7606e09aca4f9ed5c5abf15.svg";